// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";

function toCurrency(a) {
  return Number(a.toFixed(2));
}

function fromCurrency(a) {
  return a;
}

function toStrictCurrency(a) {
  return a | 0;
}

function fromStrictCurrency(a) {
  return a;
}

function fromOptCurrency(a) {
  return Belt_Option.mapWithDefault(a, undefined, (function (b) {
                return b;
              }));
}

function add(a, b) {
  var a$1 = a + b;
  return Number(a$1.toFixed(2));
}

function subtract(a, b) {
  var a$1 = a - b;
  return Number(a$1.toFixed(2));
}

function toCurrencyString(a, symbol) {
  var prefix = a < 0.0 ? "-" : "";
  var value = Math.abs(a).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return prefix + (" " + (symbol + (" " + value)));
}

function toRoundedString(a, symbol) {
  var prefix = a < 0.0 ? "-" : "";
  var value = Math.abs(a).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return prefix + (" " + (symbol + (" " + value)));
}

function toTwoDigitPrecisionString(a, symbol) {
  var prefix = a < 0.0 ? "-" : "";
  var value = Math.abs(a).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return prefix + (" " + (symbol + (" " + value)));
}

function toString(a) {
  return a.toString();
}

function fromString(a) {
  return Number(Number(a).toFixed(2));
}

export {
  toCurrency ,
  fromCurrency ,
  toStrictCurrency ,
  fromStrictCurrency ,
  fromOptCurrency ,
  add ,
  subtract ,
  toString ,
  toCurrencyString ,
  toRoundedString ,
  toTwoDigitPrecisionString ,
  fromString ,
  
}
/* No side effect */
